export class UserBooking {
    constructor(isAllDay, date, startTime, endTime, booking) {
        this.isAllDay = isAllDay;
        this.date = date;
        this.startTime = startTime;
        this.endTime = endTime;
        this.booking = booking;
    }
}
